import { CompanyDto } from './companyDto'
import { OutboundTripDto } from './outboundTripDto'

export class NeedsToBeMovedToStagingDetailsDto {
  vin?: string = undefined
  year?: number = undefined
  make?: string = undefined
  model?: string = undefined
  importerStockNumber?: string = undefined
  exporterCompany?: CompanyDto = undefined
  buyerCompany?: CompanyDto = undefined
  warrantyCertPhotoFileName?: string = undefined
  warrantyCertPhotoFile?: File = undefined

  readyForOutboundDateTime?: string = undefined
  vehicleReleaseDateTime?: string = undefined
  bondReleaseDateTime?: string = undefined
  outboundTrip?: OutboundTripDto = undefined
}
